import assert from '../assert';
import isPlainObject from './is-plain-object';
import isFunction from './is-function';

export default options => {
  assert(
    isPlainObject(options),
    `
    Options needs to be a plain javascript object.
    Received: ${typeof options}
  `
  );

  assert(
    isFunction(options.run),
    `
    You must provide a run function. This is the function
    that will be invoked to execute the operation and should
    return a promise.

    Currently: ${typeof options.run}
  `
  );

  assert(
    isFunction(options.accept),
    `
    You must provide an accept function. This function will
    be invoked any time the entity is mutated and should
    update the entity in the application state.

    Currently: ${typeof options.run}
  `
  );
};
